import React from 'react';
import { productDisclosureStatementUrl } from 'scenes/common/helpers/contacts';

import { TextSmall } from 'components/chroma/extended';
import { Text } from 'components/chroma';
import { Superscript } from 'components/Superscript';

export const listItems = [
  <Text listkey="backedByIag">
    Coles Insurance is backed by Australia’s largest insurer, IAG.
  </Text>,
  <Text listkey="lifetimeGuarantee">
    Lifetime Guarantee on all building repairs we authorise and arrange.{' '}
    <Superscript>+</Superscript>
  </Text>,
  <Text listkey="lodgeAndManageOnline">
    Lodge and manage a claim 24/7 through our online Insurance Service Centre.
  </Text>,
  <Text listkey="australianBasedClaimSpecialists">
    Australian-based claims specialists to help you through the claims process.
  </Text>,
];

export const supportFootnote = (
  <TextSmall margin={{ top: 4 }}>
    + Policy limitations, exclusions and conditions apply. For full terms and
    conditions, see the{' '}
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </TextSmall>
);

export const totalLossSettlementText = (
  <Text>
    If your rental property is considered a total loss, the claim settlement
    won’t include the return of any premium you have already paid during the
    period of insurance. If you’re paying in monthly instalments, we’ll deduct
    the remaining instalments from the amount we pay for the claim.
  </Text>
);
